import React, {useState, useEffect, useCallback} from 'react';
import {Typography} from "@material-ui/core";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import WarningIcon from '@mui/icons-material/Warning';
import PersonalDetails from "./Steps/PersonalDetails";
import Education from "./Steps/Education";
import Experience from "./Steps/Experience";
import Skills from "./Steps/Skills";
import AdditionalQuestions from "./Steps/AdditionalQuestions";
import ApplicationDetails from "./Steps/ApplicationDetails";
import Completed from "./Steps/Completed";
import keycloak from "../../Keycloak";
import {
    editCV,
    getIdNumber,
    postCV,
    postExternalCV,
    parseCV,
    getJobById,
    startApplicationFlow, getCvsByJobId, manualCreateCv, getCompanyLogoByJobHashCode
} from "../../utilities/cvAPI";
import {toast} from "react-toastify";
import Enums from "../General/Enums";
import ApplicationLandingPage from "./Steps/ApplicationLandingPage";
import Modal from '@mui/material/Modal';
import CircularProgress from "@mui/material/CircularProgress";
import SEOTags from "../SEOTags";
import webtonicLogo from "../Images/tonichub-dark.png";
import EditorState from "draft-js/lib/EditorState";
import {convertFromRaw} from "draft-js";
import "../CV/CV.css"
import config from "../../config";
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2
}

export let formValidations = [
    {'valid': true},
    {'valid': false},
    {'valid': false},
    {'valid': false},
    {'valid': false},
    {'valid': false},
    {'valid': true},
]

export default function CVTemplate({jobId}) {
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Start", "Personal Details", "Education", "Experience", "Skills", "Additional Questions", "Application Summary", "Completed!"];
    const stepsInternal = ["CV Details", "Completed!"];
    const [errorMessage, setErrorMessage] = useState("");
    const [displayCV, setDisplayCV] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [jobPlacement , setJobPlacement]=useState("");
    const [workModel, setWorkModel] = useState("")
    const [jobTitle, setJobTitle] = useState("");
    const [isNewCV, setIsNewCV] = useState(true);
    const [cv, setCV] = useState(Enums.cv);
    const [uploadedCV, setUploadedCV] = useState(null);
    // const isCvParserActivated = useFlag(Enums.FeatureFlags.CVParser);
    const isCvParserActivated = true;
    const [userHasClickedNext, setUserHasClickedNext] = useState(false);
    const [enableNext, setEnableNext] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [idExists, setIdExists] = useState(false);
    const [sessionId, setSessionId] = useState(null);
    const [metaInformation, setMetaInformation] = useState({});
    const [job, setJob] = useState([]);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const showSaveSuccess = (string) => {
        toast.success(string, {
            position: toast.POSITION.TOP_LEFT,
            style: {
                backgroundColor: "#49c96d",
                width: "650px",
                color: "#FFFFFF",
                left: "500px",
                theme: "colored",
            },
        });
    };

    const showErrorToast = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_LEFT,
            style: {
                backgroundColor: "#eb4335",
                width: "650px",
                color: "#FFFFFF",
                left: "500px",
                theme: "colored",
            },
        });
    };

    const callGetCV = useCallback(() => {
        if (jobId) {
            cv.jobHash = jobId;
            cv.type = "External";
            getJobById(jobId)
                .then(async (job) => {
                    if (job) {
                        setDisplayCV(true);
                        setJobTitle(job.jobTitle);
                        setJobPlacement(job.jobDetails.jobPlacement);
                        setWorkModel(job.jobDetails.workModel);
                        setJob(job);

                        const logoData = await getCompanyLogoByJobHashCode(job.hashedCode);
                        let logoUrl = webtonicLogo;
                        if (logoData) {
                            const s3FileName = logoData.s3FileName;
                            // const logoFile = await getDocumentFile(s3FileName);
                            // logoUrl = URL.createObjectURL(logoFile);
                            console.log(config.cloudfront_url + s3FileName)
                            logoUrl = config.cloudfront_url + s3FileName
                        }

                        setMetaInformation({
                            meta_title: job.jobTitle,
                            meta_description: job.jobDetails.description,
                            og_image: logoUrl,
                        });

                        const contentBlock = job.jobDetails.rolesResponsibilities;
                        if (contentBlock) {
                            const contentState = convertFromRaw(JSON.parse(contentBlock));
                            const newEditorState = EditorState.createWithContent(contentState);
                            setEditorState(newEditorState);
                        }
                    } else {
                        throw new Error();
                    }
                })
                .catch((e) => {
                    setDisplayCV(false);
                    setErrorMessage("Job not found");
                    console.log(e);
                });
        } else if (keycloak?.hasResourceRole("internal_user")) {
            cv.jobId = jobId;
            cv.type = "Internal";
            getIdNumber(keycloak.token)
                .then((cvData) => {
                    console.log("CV Data: ", cvData);
                    if (cvData) {
                        setCV(cvData);
                        setIsNewCV(false);
                        setIsLoading(false);
                        setDisplayCV(true);
                    } else {
                        setIsNewCV(true);
                        setIsLoading(false);
                        setDisplayCV(true);
                    }
                })
                .catch((e) => {
                    setIsLoading(false);
                    console.log(e);
                    setErrorMessage("Missing ID number, speak to your Administrator");
                    setDisplayCV(false);
                });
        }
    }, [cv, setCV, jobId]);

    useEffect(() => {
        callGetCV();
    }, [callGetCV]);

    useEffect(() => {
        setEnableNext(activeStep > 0 || uploadedCV !== null);
    }, [activeStep, uploadedCV]);

    const savePersonalDetails = async () => {
        if (!isNewCV) {
            editCV(cv.id, cv, keycloak.token)
                .then(() => {
                    let string = "CV successfully updated";
                    showSaveSuccess(string);
                })
                .catch(() => console.log("Could not update CV"));
        } else if (keycloak?.hasResourceRole("internal_user") && !jobId) {
            postCV(cv, keycloak.token)
                .then(() => {
                    let string = "CV successfully saved";
                    showSaveSuccess(string);
                })
                .catch(() => console.log("Could not save CV"));
        } else if (!idExists){
            postExternalCV(cv, sessionId)
                .then(() => {
                    handleNext();
                })
                .catch(() => console.log("Could not upload CV"));
        }
    };

    const updateCV = (section, data) => {
        setCV((prevCV) => ({
            ...prevCV,
            [section]: data,
        }));
    }

    const canUploadAndParseCv = () => {
        return (isCvParserActivated && isNewCV && activeStep === 0 && uploadedCV != null);
    }

    const checkIdExists = (idNumber) => {
        getCvsByJobId(jobId, keycloak.token)
            .then((cvData) => {
                console.log("CV Data: ", cvData);
                if (cvData && Array.isArray(cvData)) {
                    const idNumbers = new Set(cvData.map(item => item.personalDetails?.idNumber));
                    if (idNumbers.has(idNumber)) {
                        setShowPopup(true);
                        setIdExists(true);
                    } else {
                        setIdExists(false);
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    }
                }
            })
            .catch((e) => {
                console.log(e);
                setErrorMessage("Missing ID number, speak to your Administrator")
            });
    };

    const handleNext = (event) => {
        if (formValidations[activeStep].valid) {
            console.log(formValidations[activeStep].valid);
            setUserHasClickedNext(false);
            const forceManual = event?.target?.id === "createCvManual";
            if (forceManual) {
                applicationStartManualCv();
            } else if (canUploadAndParseCv()) {
                uploadAndParseCv();
            } else if (activeStep === 6) {
                setActiveStep((prevActiveStep) => prevActiveStep + 2);
            } else if (activeStep === 1) {
                checkIdExists(cv.personalDetails.idNumber);
            } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
            window.scrollTo(0, 0);
        } else {
            setUserHasClickedNext(true);
            callGetCV();
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setUserHasClickedNext(false)
    }

    const handleSubmit = () => {
        savePersonalDetails()
    }

    const handleCvUploaded = (files) => {
        setUploadedCV(files.length > 0 ? files[0] : null);
    }

    const uploadAndParseCv = () => {
        setIsLoading(true);
        startApplicationFlow().then((sessionCode) => {
            setSessionId(sessionCode);
            parseCV(uploadedCV, sessionCode)
                .then(response => {
                    setCV(response);
                    setUploadedCV(null); // Prevent double upload
                    setIsLoading(false);
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                })

        }).then(() => {
            window.scrollTo(0, 0);
        }).catch(() => {
            setIsLoading(false);
            showErrorToast("Failed to upload CV");
        });
    }

    const applicationStartManualCv = () => {
        startApplicationFlow()
            .then((sessionCode) => {
                setSessionId(sessionCode)
                manualCreateCv(sessionCode).then( () =>
                    setActiveStep((prevActiveStep) => prevActiveStep + 1)
                )
            })
    }

    const renderStepContent = () => {
        if (isNewCV) {
            switch (activeStep) {
                case 0:
                    return <ApplicationLandingPage handleNext={handleNext} jobTitle={jobTitle}
                                                   cvUploaded={handleCvUploaded} job={job} jobResponsibilities={editorState}/>;
                case 1:
                    return <PersonalDetails personalDetails={cv.personalDetails} updateCV={updateCV}
                                            userHasClickedNext={userHasClickedNext}/>;
                case 2:
                    return <Education education={cv.education} updateCV={updateCV}
                                      userHasClickedNext={userHasClickedNext}/>;
                case 3:
                    return <Experience experience={cv.experience} updateCV={updateCV}
                                       userHasClickedNext={userHasClickedNext}/>;
                case 4:
                    return <Skills skills={cv.skills} updateCV={updateCV} userHasClickedNext={userHasClickedNext}/>;
                case 5:
                    return <AdditionalQuestions additionalQuestions={cv.additionalQuestions} updateCV={updateCV}
                                                userHasClickedNext={userHasClickedNext} jobPlacement={jobPlacement} workModel={workModel}/>;
                case 6:
                    return <ApplicationDetails cv={cv} updateCV={updateCV} jobPlacement={jobPlacement} workModel={workModel}/>;
                case 7:
                    return <Completed/>;
                default:
                    return <Completed/>;
            }
        } else {
            switch (activeStep) {
                case 0:
                    return <ApplicationDetails cv={cv} updateCV={updateCV}/>;
                case 1:
                    return <Completed/>;
                default:
                    return null;
            }
        }
    }

    return (
        <React.Fragment>
            <SEOTags metaInformation={metaInformation}  />

            <Modal
                open={isLoading}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Grid container direction={"column"} alignItems={"center"} padding={2} spacing={2}>
                        <Grid item xs={12}>
                            <h4>
                                Uploading and Analysing
                            </h4>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={"text-3"}>
                                Bare with our AI, he's not perfect but he's trying his best ಠ_ಠ
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <CircularProgress sx={{color: "#FF6600"}}/>
                        </Grid>
                        <Grid item xs={12}/>
                        <Grid item xs={12}>
                            <Button style={{
                                float: "right",
                                backgroundColor: '#FF6600',
                                width: '89px',
                                height: '40px',
                                fontFamily: 'Poppins',
                                color: '#FFFFFF',
                                marginLeft: 'auto',
                            }}>Cancel</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Grid item>
                <h5 id={"missingIdNumber"} hidden={displayCV}
                    style={{marginLeft: "40px", marginTop: "40px"}}>{errorMessage}</h5>
            </Grid>

            <div id={"CV"} data-testid="CV" hidden={!displayCV}>
                <div className={"application-title-container"}>
                    <Typography component="h1" variant="h4" align="center" style={{margin: '1%'}}>
                        {jobTitle}
                    </Typography>
                </div>

                <Stepper activeStep={activeStep} alternativeLabel={true} sx={{
                    '& .MuiStepLabel-root .Mui-completed': {
                        color: '#0DAE4A', // circle color (COMPLETED)
                    },
                    '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                        {
                            color: '#0DAE4A', // Just text label (COMPLETED)
                        },
                    '& .MuiStepLabel-root .Mui-active': {
                        color: '#FF6600', // circle color (ACTIVE)
                    },
                    '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                        fill: 'white', // circle's number (ACTIVE)
                    }
                }}>
                    {isNewCV
                        ? steps.map((label, index) => (
                            <Step key={label} completed={(index < activeStep)}>
                                <StepLabel>
                                    <text-4>
                                        {label}
                                    </text-4>
                                </StepLabel>
                            </Step>
                        ))
                        : stepsInternal.map((label, index) => (
                            <Step key={label} completed={(index < activeStep)}>
                                <StepLabel color="inherit" className={"text-4"}>
                                    {label}
                                </StepLabel>
                            </Step>
                        ))
                    }
                </Stepper>

                <Box xs={12} sx={{marginLeft: '5%', marginTop: '5%', marginBottom: '5%', width: '90%'}}>
                    <Paper>
                        <Grid container direction={"row"} spacing={2} padding={2} justifyContent={"flex-start"}
                              alignContent={"center"}>
                            {renderStepContent()}
                            {(!isNewCV && (activeStep === 0)) || (isNewCV && (activeStep === 6)) ? (
                                <div style={{float: "right", marginLeft: 'auto', marginRight: '35px'}}>
                                    <Button data-testid={"save-button"} onClick={() => {
                                        handleSubmit();
                                    }
                                    }
                                            style={{
                                                float: "right",
                                                backgroundColor: '#FF6600',
                                                width: '89px',
                                                height: '40px',
                                                fontFamily: 'Poppins',
                                                color: '#FFFFFF',
                                                marginLeft: 'auto',
                                            }}>Submit</Button>
                                    <Button data-testid={"back-button"} onClick={handleBack}
                                            hidden={activeStep !== 6}
                                            variant={"outlined"}
                                            style={{
                                                float: "right",
                                                color: '#FF6600',
                                                width: '89px',
                                                height: '40px',
                                                fontFamily: 'Poppins',
                                                borderColor: '#FF6600',
                                                marginLeft: 'auto',
                                                marginRight: '30px'
                                            }}>Back</Button>
                                </div>
                            ) : (
                                isNewCV && (activeStep < 6) ?
                                    (
                                        <div style={{float: "right", marginLeft: 'auto', marginRight: '35px'}}>
                                            <Button data-testid={"next-button"} onClick={handleNext}
                                                    style={{
                                                        float: "right",
                                                        backgroundColor: enableNext ? '#FF6600' : '#B0B0B0',
                                                        width: '89px',
                                                        height: '40px',
                                                        fontFamily: 'Poppins',
                                                        color: enableNext ? '#FFFFFF' : '#D6D6D6',
                                                        marginLeft: 'auto',
                                                        cursor: enableNext ? 'pointer' : 'default'
                                                    }}
                                                    disabled={!enableNext}
                                            >
                                                Next
                                            </Button>
                                            <Button data-testid={"back-button"} onClick={handleBack}
                                                    hidden={activeStep <= 0}
                                                    variant={"outlined"}
                                                    style={{
                                                        float: "right",
                                                        color: '#FF6600',
                                                        borderColor: '#FF6600',
                                                        width: '89px',
                                                        height: '40px',
                                                        fontFamily: 'Poppins',
                                                        marginLeft: 'auto',
                                                        marginRight: '30px'
                                                    }}>Back
                                            </Button>
                                        </div>
                                    )
                                    : ("")
                            )}
                        </Grid>
                    </Paper>

                    <Modal
                        open={showPopup}
                        onClose={() => setShowPopup(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '30%',
                            height: '40%',
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            p: 2
                        }}>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    <WarningIcon style={{ color: 'red', marginRight: '8px', width: '310px',
                                        height: '75px', }} />
                                </Typography>
                            </Box>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', marginTop: "10%" }}>
                                <Typography id="modal-modal-description" sx={{mt: 2, fontFamily: 'Poppins',}}>
                                    The ID you entered already exists for a job profile
                                </Typography>
                            </Box>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', marginTop: "10%" }}>
                                <Button
                                    style={{
                                        backgroundColor: '#FF6600',
                                        fontFamily: 'Poppins',
                                        width: '110px',
                                        height: '25px',
                                        color: '#FFFFFF',
                                        borderRadius: '5px',
                                    }}
                                    variant="contained"
                                    onClick={() => setShowPopup(false)}
                                >
                                    Ok
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            </div>
        </React.Fragment>
    );
}
